export const alertConstantes = Object.freeze({
  NEUTRAL: 0,
  ALERT_INFO: 1,
  ALERT_WARNING: 2,
  ALERT_DANGER: 3,
});
